import Component from '../core/Component'
import EventBus from '../core/EventBus'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import PositionObserver from '../meta/PositionObserver'
import Scroll from '../services/Scroll'
import throttle from 'lodash/throttle'

export default class Awards extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            lists: [],
            visual: null,
            content: null,
            title: null,
            titleWrapper: null,
        }

        this.state = {
            visible: false,
            list: {
                active: false,
            },
            visual: {
                min: 0,
                offset: 0,
            },
            title: {
                min: 0,
                fixed: false,
            },
        }

        this.enquireHandler = {
            match: this.attachListView,
            unmatch: this.detachListView,
        }

        this.handleAwardVisualShow = throttle(this.handleAwardVisualShow, 500)
    }

    prepare() {
        this.lists = this.ref.lists.map((element) => Component.getFromElement(element))

        this.lists.forEach((list) => {
            list.on('item:enter', this.handleItemEnter)
            list.on('item:leave', this.handleItemLeave)
        })

        this.visual = Component.getFromElement(this.ref.visual)
        this.ref.content.addEventListener('mouseleave', this.handleContentLeave)

        EventBus.on('award:visual:show', this.handleAwardVisualShow)
        enquire.register(queries.smallWideMax, this.enquireHandler)
    }

    destroy() {
        EventBus.off('award:visual:show', this.handleAwardVisualShow)
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
    }

    attachListView = () => {
        this.state.list.active = true
        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter,
            onLeave: this.handleLeave,
            onRender: this.handleRender,
            onBeforeResize: this.handleResize,
        })
    }

    detachListView = () => {
        this.state.list.active = false
        this.state.title.fixed = false
        this.observer?.destroy()
        this.observer = null
        this.ref.visual.removeAttribute('style')
        this.ref.title.removeAttribute('style')
        this.ref.title.classList.remove('is-fixed')
        this.ref.titleWrapper.removeAttribute('style')
    }

    handleEnter = () => {
        this.state.visible = true
        this.ref.visual.classList.add('is-visible')
        if (this.state.title.fixed) {
            this.ref.title.classList.add('is-fixed')
        }
    }

    handleLeave = () => {
        this.state.visible = false
        this.ref.visual.classList.remove('is-visible')
        this.ref.title.classList.remove('is-fixed')
    }

    handleResize = () => {
        const y = Scroll.getScroll().y
        const visualBox = this.ref.visual.getBoundingClientRect()
        const sectionBox = this.element.getBoundingClientRect()
        const windowHeight = window.innerHeight
        const titleBox = this.ref.title.getBoundingClientRect()

        this.state.visual.min = y + sectionBox.top
        this.state.visual.offset = (windowHeight - visualBox.height) / 2
        this.state.title.min = y + sectionBox.top

        this.ref.titleWrapper.style.height = `${titleBox.height}px`
    }

    handleRender = ({ scrollY }) => {
        if (!this.state.visible) {
            return
        }

        this.ref.visual.style.transform = `translate(-50%, ${
            scrollY - this.state.visual.min + this.state.visual.offset
        }px)`

        const titleOffset = Math.max(0, scrollY - this.state.title.min)

        if (titleOffset > 0) {
            if (!this.state.title.fixed) {
                this.state.title.fixed = true
                this.ref.title.classList.add('is-fixed')
            }
        } else {
            if (this.state.title.fixed) {
                this.state.title.fixed = false
                this.ref.title.classList.remove('is-fixed')
            }
        }

        this.ref.title.style.transform = `translateY(${titleOffset}px)`
    }

    handleAwardVisualShow = (data) => {
        this.visual.show(data)
    }

    handleItemEnter = (data) => {
        if (this.state.list.active) {
            return
        }

        this.visual.show(data)
    }

    handleItemLeave = () => {
        if (this.state.list.active) {
            return
        }

        this.visual.hide()
    }

    handleContentLeave = () => {
        if (this.state.list.active) {
            return
        }

        this.visual.hide(true)
    }
}
